<template lang="pug">
  ion-col
    ion-card
      ion-card-content
        ion-card-header
          ion-card-title Solicitud: 
            strong # {{ returnNumberID(cardInfo.id) }}
        ion-card-subtitle 
          ion-item-divider
            ion-label Parametros de la solicitud
        p 
          | <br/> Departamento: {{ cardInfo.departamento }}
          | <br/> Area de maniobra: {{ cardInfo.AreaManiobra }}
          | <br/> Altura: {{ cardInfo.altura}}
          | <br/> Peso: {{ cardInfo.peso}}
          | <br/> Radio: {{ cardInfo.radio }}
          | <br/> Descripción: {{ cardInfo.descripcion }}
        
        ion-card-subtitle 
          ion-item-divider
            ion-label  Resumen del servicio
        p 
          | <br/> Fecha de servicio: {{ getDateFormat(cardInfo.fecha,"D","dddd dd") + ' de ' + getDateFormat(cardInfo.fecha,"D","mmmm yyyy") }} {{ getDateFormat(cardInfo.hora,'T') }}
          | <br/> Grúa: {{cardInfo.gruaTipo}}
          | <br/> Operador: {{ cardInfo.Operador }}

        ion-card-subtitle( v-if="itFinish" ) 
          ion-item-divider
            ion-label  Comentarios
        p( v-if="itFinish" ): i {{ getComentarios(cardInfo.comentarioCliente ) }}
      ion-item-divider
      ion-row.mtb-20()
        ion-chip
          ion-label OT: {{ cardInfo.OT }}
        ion-chip
          ion-label Fecha de Servicio: {{ getDateFormat(cardInfo.fecha,"D")}}
      

</template>
<style lang="scss">
  .mtb-20{margin-top: 15px;margin-bottom: 15px; }
	.btn-flat{
		width: 100%;
		min-height: 40px;
		font-size: 15px;
		background: transparent;
  }
  
</style>
<script>

import {func} from '../func.js'
export default {
  components: {},
  name: "SimpleCardFinalizado",
  props: ["cardInfo","itFinish"],
  methods: {
    getComentarios($s){ return  ( $s.length > 2 )? $s: "N/A" ; },
    returnNumberID(_string){
      return func.returnID(_string);
    },
    sendWhatsAppMessge(){
      let _link = "https://wa.me/528120109930?text=Me%20pueden%20dar%20informes%20sobre%20la%20solicitud:%20"+this.cardInfo.id.substring(0,5);
      // window.location.href = _link;
      window.open(
        _link,
        '_blank' // <- This is what makes it open in a new window.
      );
    },
    getDateFormat(a,b,c){
      return func.getDateFormat(a,b,c);
    },
    getResumen(v, str_id) {
      let _self = this;
      let f = func.getDateFormat(_self.cardInfo.fecha,"D");
      let h = func.getDateFormat(_self.cardInfo.hora,"H");
      let tit = "Resumen de la sollicitud";
      let msg ="";
      if(v == 1){
        msg = `<p> Tu solicitúd sera atendida el dia ${ f } a las: ${h} <br /> 
                  por el operador: ${_self.cardInfo.Operador}, en la unidad numero: ${_self.cardInfo.Unidad }`; 
        return this.$ionic.alertController
          .create({
            header: tit,
            message: msg,
            buttons: ["Aceptar"]
          })
          .then(a => a.present());
      }else{
        let _showE = document.querySelector("#ID-"+this.cardInfo.id);
        _showE.style.display = "block";
        msg = `<p> Tu solicitúd sera atendida el dia ${ f } a las: ${h} <br /> 
                  por el operador: ${_self.cardInfo.Operador}, en la unidad numero: ${_self.cardInfo.Unidad } <br/>
                  La orden de trabajo para esta solicitud es: <strong>${_self.cardInfo.OT} </strong> </p>`; 
        _self.openModal(msg,str_id);
      }
    },

    getLabelCard(st) {
      let _label = st[0];
      if ( this.cardInfo.revisionOP == true ){
        return "Aceptada";
      }

      if(st.length > 2 ){
        if( st[2] == "Modificada" ){
          _label = st[2];
        }
      }
      return _label
    },
    presentAlertRadio() {
      return this.$ionic.alertController
        .create({
          header: 'Radio',
          inputs: [
            {
              type: 'radio',
              label: 'Radio 1',
              value: 'value1',
              checked: true,
            },
            {
              type: 'radio',
              label: 'Radio 2',
              value: 'value2',
            },
            {
              type: 'radio',
              label: 'Radio 3',
              value: 'value3',
            },
          ],
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
                console.log('Confirm Cancel')
              },
            },
            {
              text: 'Ok',
              handler: () => {
                console.log('Confirm Ok')
              },
            },
          ],
        })
        .then(a => a.present())
    },
    getCardColor($color) {
      if ( this.cardInfo.revisionOP == true )
        return "success";
      let _color = null;
      switch ($color) {
        case 0:
          _color = "success"
          break;
        case 1:
          _color = "warning"
          break;
        case 3:
          _color = "danger"
          break;
      
        default:
          _color = "tertiary"
          break;
      }
      return _color;
    }
  },
  created(){
  }
};
</script>